import {Component, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {DateTimeType} from 'hateoas-navigator';
import {DatePickerField} from 'hateoas-navigator';

@Component({
  selector: 'app-date-time-field',
  template: `<!--<mat-form-field [formGroup]="form" class="cmp-full-width">-->
<!-- Angular Material currently only supports dates, therefore another library is used until this is supported -->
<!--<input matInput [matDatepicker]="picker" [placeholder]="field.getTitle()" [formControlName]="field.name">-->
<!--<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>-->
<!--<mat-datepicker #picker></mat-datepicker>-->
<!--</mat-form-field>-->
<md2-datepicker class="cmp-full-width" [type]="getType()" [required]="field.isRequired()" [placeholder]="field.getTitle()"
                [formControl]="control"></md2-datepicker>
`,
  styles: [``, `.cmp-full-width{width:100%}`]
})
export class DateTimeFieldComponent {
  @Input()
  field: DatePickerField;

  @Input()
  control: AbstractControl;

  getType(): string {
    switch (this.field.getDateTimeType()) {
      case DateTimeType.DATE:
        return 'date';
      case DateTimeType.TIME:
        return 'time';
      case DateTimeType.DATE_TIME:
        return 'datetime';
      default:
        throw new Error('Missing date/time type for ' + this.field.getName());
    }
  }
}
